import React from 'react';
//UI components
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button';
import Label from 'components/form/Label/Label';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { getCreditScoreBandI } from 'helpers/tracking.helpers';
//tracking sensor
import VisibilitySensor from 'react-visibility-sensor';
import '../../../../components/Image/Image.scss';
import './CROABanner.scss';
import { useViewModule } from 'hook/helper.hook';
import { getDaysSinceWithNull } from 'helpers/dateHelper';
import useTrackingMetadata from 'externals/_tracking/useTrackingMetadata';

const CROAVar1 = props => {
  return (
    <div className="CroaVar1 ">
      {/* Dektop View */}
      <FlexContainer className="justify-between mobileOnlyHide margB20 format100">
        <div className="upsell-img croaCreditSesameBanner mobileOnlyHide padT20 margT20">
          <FlexContainer className="padT20 format80 flex-column content-align-start">
            <Label className="Heading h1-title mobileOnlyHide lineHeight-1-33 fontBlue100 bold">
              {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
            </Label>
            <div className="padT20 format60  mobileOnlyHide">
              <div className="">
                <Button
                  className="upsell-CTA fullWidth"
                  mrphType="primary"
                  onClick={props.handleCTAClick}
                >
                  <Label className="upsell-btn-copy"></Label>
                </Button>
              </div>
            </div>
            <Label className="padT14 body1 h3-disclaimer  mobileOnlyHide lineHeight-1-33   ">
              {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
            </Label>
            <Label className="h4-cancel mobileOnlyHide padT14  text-12 fontGray200  ">
              {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
            </Label>
          </FlexContainer>
        </div>

        <div className="croaImgVar1 croaVar1 mobileOnlyHide" />
      </FlexContainer>

      {/* Dektop View */}

      {/* Mobile View */}

      <FlexContainer className="nonMobileHide justify-center m-padB20 m-padT12">
        <div className="upsell-img freePremiumOfferVar4-logo-mweb nonMobileHide " />
      </FlexContainer>

      <div className="m-killPad m-format100 nonMobileHide">
        <Label className="Heading m-pad8 h1-title nonMobileHide m-text-center fontBlue100 bold">
          {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
        </Label>
      </div>

      <div className=" m-format100  m-pad8 nonMobileHide">
        <div className="m-format100  m-pad8">
          <Button
            mrphType="primary"
            className="upsell-CTA fullWidth"
            onClick={props.handleCTAClick}
          >
            <Label className="upsell-btn-copy upsell-btn-copyMobile">
              {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
            </Label>
          </Button>
        </div>
      </div>
      <div className="croaImgVar1-m croaVar1-m  m-format100 nonMobileHide m-margT10" />
      <Label className="m-padL16 m-padR16 m-padT16 mBody-1 h3-disclaimer  nonMobileHide lineHeight-1-33">
        {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
      </Label>
      <Label className="h4-cancel nonMobileHide m-pad16  text-12 fontGray200  ">
        {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
      </Label>
      {/* Mobile View */}
    </div>
  );
};

const CROAVar2 = props => {
  return (
    <div className="CroaVar2 ">
      {/* Dektop View */}
      <FlexContainer className="justify-between mobileOnlyHide margB20 padT8 format100">
        <div className="upsell-img croaCreditSesameBanner format100 mobileOnlyHide padT20 margT10">
          <FlexContainer className="padT20 t-format80 format100 flex-column content-align-start">
            <Label className="Heading h1-title mobileOnlyHide lineHeight-1-33 fontBlue100 bold">
              {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
            </Label>
            <div className="format60 margT10 mobileOnlyHide">
              <div className="">
                <Button
                  className="upsell-CTA fullWidth"
                  mrphType="primary"
                  onClick={props.handleCTAClick}
                >
                  <Label className="upsell-btn-copy"></Label>
                </Button>
              </div>
            </div>
            <Label className="padT14 body1 h3-disclaimer  mobileOnlyHide lineHeight-1-33 bold  ">
              {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
            </Label>
            <Label className="h4-cancel mobileOnlyHide padT40  text-12 fontGray200  ">
              {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
            </Label>
          </FlexContainer>
        </div>
        <FlexContainer className="flex-column format25">
          <div className="upsell-img croaVar2a mobileOnlyHide" />
          <div className="padB4" />
          <div className="upsell-img margL12 croaVar2b mobileOnlyHide" />
        </FlexContainer>
      </FlexContainer>

      {/* Dektop View */}

      {/* Mobile View */}

      <FlexContainer className="nonMobileHide justify-center padB20 padT12">
        <div className="upsell-img freePremiumOfferVar4-logo-mweb nonMobileHide " />
      </FlexContainer>

      <div className="m-killPad  m-format100 nonMobileHide">
        <Label className="Heading h1-title nonMobileHide m-text-center fontBlue100 bold">
          {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
        </Label>
      </div>
      <FlexContainer className="flex-row m-padL24 m-padR24">
        <div className="upsell-img croaVar2a-m nonMobileHide" />
        <div className="m-padL18" />
        <div className="upsell-img croaVar2b-m nonMobileHide" />
      </FlexContainer>

      <div className=" m-format100 m-padL24 m-padR24 nonMobileHide">
        <div className="">
          <Button
            mrphType="primary"
            className="upsell-CTA fullWidth"
            onClick={props.handleCTAClick}
          >
            <Label className="upsell-btn-copy m-padL24 m-padR24 ">
              {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
            </Label>
          </Button>
        </div>
      </div>
      <Label className="m-padL24 m-padR24 m-padT8 body1 h3-disclaimer  nonMobileHide  ">
        {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
      </Label>
      <Label className="h4-cancel nonMobileHide m-padL24 m-padR24 m-padT8  text-12 fontGray200  ">
        {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
      </Label>
      {/* Mobile View */}
    </div>
  );
};

const CROAVar3 = props => {
  return (
    <div className="CroaVar3 ">
      {/* Dektop View */}
      <FlexContainer className="justify-between mobileOnlyHide margB20 padT8 format100">
        <div className="upsell-img croaCreditSesameBanner format100 mobileOnlyHide padT20">
          <FlexContainer className="padT20 t-format80 format80 flex-column content-align-start">
            <Label className="Heading h1-title mobileOnlyHide lineHeight-1-33 fontBlue100 bold">
              {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
            </Label>
            <div className="padT20 format60 margT10 mobileOnlyHide">
              <div className="">
                <Button
                  className="upsell-CTA fullWidth"
                  mrphType="primary"
                  onClick={props.handleCTAClick}
                >
                  <Label className="upsell-btn-copy"></Label>
                </Button>
              </div>
            </div>
            <Label className="padT14 body1 h3-disclaimer  mobileOnlyHide lineHeight-1-33   ">
              {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
            </Label>
            <Label className="h4-cancel mobileOnlyHide padT20  text-12 fontGray200  ">
              {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
            </Label>
          </FlexContainer>
        </div>

        <div className="upsell-img m-format100 mobileOnlyHide pad20">
          <div className="croaVar3" />
        </div>
      </FlexContainer>

      {/* Dektop View */}

      {/* Mobile View */}

      <FlexContainer className="nonMobileHide justify-center m-padB10 m-padT12">
        <div className="upsell-img freePremiumOfferVar4-logo-mweb nonMobileHide " />
      </FlexContainer>

      <div className="m-killPad m-format100 nonMobileHide">
        <Label className="Heading m-pad8 h1-title nonMobileHide m-text-center fontBlue100">
          {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
        </Label>
      </div>

      <div className=" m-format100  m-pad8 nonMobileHide">
        <div className="m-format100  m-pad8">
          <Button
            mrphType="primary"
            className="upsell-CTA fullWidth"
            onClick={props.handleCTAClick}
          >
            <Label className="upsell-btn-copy upsell-btn-copyMobile">
              {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
            </Label>
          </Button>
        </div>
      </div>
      <Label className="m-padL16 m-padR16 m-padT16 mBody-1 h3-disclaimer  nonMobileHide lineHeight-1-33 bold ">
        {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
      </Label>
      <div className="upsell-img croaVar3-m nonMobileHide m-margL60 m-margT14" />

      <Label className="h4-cancel nonMobileHide m-pad16  text-12 fontGray200  ">
        {/* This copy is generated with CSS on Optimizely for PMs to be able change*/}
      </Label>
      {/* Mobile View */}
    </div>
  );
};

const CROABannerVar = props => {
  if (props?.variation === 'VAR1') {
    return <CROAVar1 handleCTAClick={props.handleTurboCROACTAClick} />;
  } else if (props?.variation === 'VAR2') {
    return <CROAVar2 handleCTAClick={props.handleTurboCROACTAClick} />;
  } else if (props?.variation === 'VAR3') {
    return <CROAVar3 handleCTAClick={props.handleTurboCROACTAClick} />;
  } else {
    return '';
  }
};

export const CROABanner = props => {
  let {
    displayClasses,
    onVisibilityChange,
    handleTurboCROACTAClick,
    variation,
    creditInfo,
    userInfo,
    seenPixel,
  } = props;

  const removeSectionContainerPadding = 'padTB0 padR0 padB0';

  // const createBlueBackground = classnames({ blueBackground: isVariation3 });
  const trackingManager = useTrackingMetadata();
  const { oldPageNameMeta } = trackingManager;

  const daysLastSignedIn =
    userInfo?.previousLoginDate &&
    getDaysSinceWithNull(userInfo?.previousLoginDate);
  const loggedInCount = userInfo?.loggedInCount;
  const creditScore = creditInfo?.creditScore;
  const userSegment = userInfo?.userSegmentationNumber;

  const creditScoreBandI = getCreditScoreBandI(props?.creditInfo?.creditScore);

  useViewModule({
    'Module Name': 'Premium Banner',
    'Page Position': 'Premium Banner',
    Vertical: 'Subscription',
    'Days Last Signed In': daysLastSignedIn,
    'Logged In Count': loggedInCount,
    'Credit Score': creditScore,
    'User Segment': userSegment,
    'Referral Page (Previous Page)': oldPageNameMeta,
    'Page Name': 'Overview',
    'Plan Type': 'CROA Turbo',
    'Product Offer': 'CROA Turbo',
    'CS Band I': creditScoreBandI,
  });

  if (variation) {
    return (
      <>
        {seenPixel}
        <SectionContainer
          id="CroaBanner"
          className={`${displayClasses} ${removeSectionContainerPadding}`}
        >
          <VisibilitySensor onChange={onVisibilityChange}>
            <div className="invisible-pixel" />
          </VisibilitySensor>
          <Row type="m-padL0 padR0">
            <CROABannerVar
              variation={variation}
              handleTurboCROACTAClick={handleTurboCROACTAClick}
            />
          </Row>
        </SectionContainer>
      </>
    );
  } else {
    return null;
  }
};
